export const formatMonth = (number) => {
  switch (number) {
    case 1: return 'января';
    case 2: return 'февраля';
    case 3: return 'марта';
    case 4: return 'апреля';
    case 5: return 'мая';
    case 6: return 'июня';
    case 7: return 'июля';
    case 8: return 'августа';
    case 9: return 'сентября';
    case 10: return 'октября';
    case 11: return 'ноября';
    case 12: return 'декабря';
    default: return '/';
  }
};

/**
 * Utils for back format from "10 января 2015" to "10.01.2015" => for SEO purposes
 */

/*
const backFormatMonth = (month) => {
  switch (month) {
    case 'января': return '01';
    case 'февраля': return '02';
    case 'марта': return '03';
    case 'апреля': return '04';
    case 'мая': return '05';
    case 'июня': return '06';
    case 'июля': return '07';
    case 'августа': return '08';
    case 'сентября': return '09';
    case 'октября': return '10';
    case 'ноября': return '11';
    case 'декабря': return '12';
    default: return '01';
  }
};
*/

const convertDay = dayText => (parseInt(dayText, 10) < 10 ? '0' : '') + dayText;

/**
  * date format for SEO - ISO-8601
  * YYYY-MM-DD
*/
export const parseSEODate = (textDate) => {
  // textDate = 'YYYY-MM-DDT00:00:00'
  const date = textDate || '';
  return date.slice(0, 10);
};

/**
 * Given month string '01' to '12'
 * returns locale string for month
 */
export const formatStrMonth = numberString => formatMonth(parseInt(numberString, 10));

const pad = (num) => {
  const norm = Math.floor(Math.abs(num));
  return (norm < 10 ? '0' : '') + norm;
};

/**
 * Given ISO date formatted string, aka 2011-10-10T14:48:00
 * returns properly formatted timezone-accurate date
 */
export const convertISODateToString = (ISODate) => {
  const d = new Date(ISODate);
  return `${d.getDate()} ${formatStrMonth(d.getMonth() + 1)} ${d.getFullYear()}`;
};

/**
 * Does the same as convertISODateToString, except with time
 */
export const convertISODateTimeToString = (ISODate) => {
  const d = new Date(ISODate);
  return `${convertISODateToString(ISODate)} ${d.getHours()}:${pad(d.getMinutes())}`;
};

export const convertTStoIsoString = (timestamp) => {
  const d = new Date(parseInt(timestamp, 10));
  return ''.concat(
    `${d.getUTCFullYear()}`,
    `-${pad(d.getUTCMonth() + 1)}`,
    `-${pad(d.getUTCDate())}`,
    `T${pad(d.getUTCHours())}`,
    `:${pad(d.getMinutes())}`,
    `:${pad(d.getSeconds())}`,
  );
};
/**
 * Given ISO date formatted string without time, aka 2011-01-25
 * returns string, like 25.01 and 25.01.2011
 */
export const convertStrDateToDMFormat = (stringDate) => {
  const date = new Date(stringDate);
  return `${convertDay(date.getDate())}.${convertDay(date.getMonth() + 1)}`;
};

export const convertStrDateToDMYFormat = (stringDate) => {
  const date = new Date(stringDate);
  return `${convertDay(date.getDate())}.${convertDay(date.getMonth() + 1)}.${convertDay(date.getFullYear())}`;
};

export const isToday = (anyDate) => {
  const date = new Date(anyDate);
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const formatMonthToString = (number) => {
  switch (number) {
    case 1:
      return 'января';
    case 2:
      return 'февраля';
    case 3:
      return 'марта';
    case 4:
      return 'апреля';
    case 5:
      return 'мая';
    case 6:
      return 'июня';
    case 7:
      return 'июля';
    case 8:
      return 'августа';
    case 9:
      return 'сентября';
    case 10:
      return 'октября';
    case 11:
      return 'ноября';
    case 12:
      return 'декабря';
    default:
      return '/';
  }
};

export const getFormattedDeliveryDate = (dates, movementId, equipmentId) => {
  if (dates.length < 1) { return ''; }

  const closestDeliveryDate = new Date(dates[0]);
  const currentDate = new Date();
  const isThereNextDay = new Date(dates[1]);
  const deliveryDay = closestDeliveryDate.getDate();
  const deliveryMonth = closestDeliveryDate.getMonth() + 1;

  if (equipmentId) {
    return `После ${deliveryDay} ${formatMonthToString(deliveryMonth)} и позднее`;
  }

  if (movementId) {
    return `${deliveryDay} ${formatMonthToString(deliveryMonth)}`;
  }

  if (isToday(currentDate, closestDeliveryDate)) {
    return 'Сегодня';
  }

  return isThereNextDay ? `После ${deliveryDay} ${formatMonthToString(deliveryMonth)} и позднее` : `После ${deliveryDay} ${formatMonthToString(deliveryMonth)}`;
};
